import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { color } from '../../app/theme';
import Mask from './SettingBarMask';
import Wait from './sendSetting/Wait';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
    title: {
      fontSize: '15px',
      fontWeight: '400',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '21px',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
    },
  },
  {
    name: 'WaitSettingBar',
  },
);

const WaitSettingBar = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <div className={classes.top}>{t('wait')}</div>
      <div id="tag-setting-bar-bottom" className={classes.bottom}>
        <Wait alwaysOn />
      </div>
      <Mask mainId="tag-setting-bar-bottom" />
    </>
  );
};

export default WaitSettingBar;
